import { render, staticRenderFns } from "./Wallets.vue?vue&type=template&id=3362bd8c&scoped=true"
import script from "./Wallets.vue?vue&type=script&lang=js"
export * from "./Wallets.vue?vue&type=script&lang=js"
import style0 from "./Wallets.vue?vue&type=style&index=0&id=3362bd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3362bd8c",
  null
  
)

export default component.exports